import { Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/Add';

// Friendly empty state shown when no flow exists yet. Creating a flow is gated
// by emailMarketing:update; without it the button is disabled with a hint.
export default function FlowEmptyState({ canUpdate, busy, onCreate }) {
  return (
    <Paper
      elevation={0}
      sx={theme => ({
        p: { xs: 3, sm: 5 },
        borderRadius: 2.5,
        border: `1px dashed ${theme.palette.divider}`,
        textAlign: 'center',
      })}
    >
      <Stack spacing={1.5} alignItems='center'>
        <AccountTreeIcon color='primary' sx={{ fontSize: 44 }} />
        <Typography variant='h6' sx={{ fontWeight: 700 }}>
          Noch kein Flow vorhanden
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ maxWidth: 460 }}>
          Erstelle deinen ersten E-Mail-Flow, um automatisiert Nachrichten an deine Zielgruppe zu
          versenden.
        </Typography>
        <Button
          variant='contained'
          startIcon={busy ? <CircularProgress size={16} color='inherit' /> : <AddIcon />}
          disabled={!canUpdate || busy}
          onClick={onCreate}
        >
          Neuen Flow erstellen
        </Button>
        {!canUpdate && (
          <Typography variant='caption' color='text.secondary'>
            Zum Erstellen fehlt dir die nötige Berechtigung.
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
